/**
 * Deterministic PRNG.
 * ALL randomness in the engine must go through an instance of this.
 * Never call Math.random() from engine code.
 */

export type Prng = () => number;

/**
 * mulberry32: tiny, fast, deterministic 32-bit PRNG.
 * Returns a function that yields a number in [0, 1).
 */
export function mulberry32(seed: number): Prng {
  let a = seed >>> 0;
  return function () {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Uniform float in [min, max). */
export function randRange(rng: Prng, min: number, max: number): number {
  return min + rng() * (max - min);
}

/** Uniform integer in [min, max] inclusive. */
export function randInt(rng: Prng, min: number, max: number): number {
  return Math.floor(min + rng() * (max - min + 1));
}
